import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Bridge component that renders the mobile bottom navigation natively on iOS
// (Android builds its own tab bar and does not register this bridge). The
// native bar lives outside the WebView, so it never reloads between Turbo
// Drive visits.
//
// On each page that includes this controller we push the items + currentPath
// to native, which updates the highlighted destination. When the user taps an
// item, native replies with `{ navigate: path }` and we Turbo-visit it.
export default class extends BridgeComponent {
  static component = "bottom_nav"

  static values = {
    items: Array, // [{ key, label, icon, path, active }]
    currentPath: String,
    // LEGACY: true only on a tab-root page. iOS builds before CONEK-8829 hid
    // the bar when false; current builds keep it on every screen and ignore
    // it. Still sent so installed older builds keep working.
    isTabRoot: Boolean,
  }

  connect() {
    super.connect()
    this.send(
      "connect",
      {
        items: this.itemsValue,
        currentPath: this.currentPathValue,
        isTabRoot: this.isTabRootValue,
      },
      (response) => {
        this.handleNavigation(response)
      },
    )
  }

  disconnect() {
    // Tell native to hide the bar when leaving a page that has no bottom nav
    // (e.g. login). If the next page also has the controller, its `connect`
    // re-shows the bar immediately.
    if (this.enabled) {
      this.send("disconnect", {})
    }
    super.disconnect()
  }

  handleNavigation(data) {
    if (!data?.navigate) return
    const path = data.navigate
    if (window.Turbo) {
      window.Turbo.visit(path, { action: "replace" })
    } else {
      window.location.href = path
    }
  }
}
